export default __webpack_public_path__ + "static/media/Cap.f2a77a62.svg";